import { render, staticRenderFns } from "./PortalHeader.vue?vue&type=template&id=fda07078&scoped=true"
import script from "./PortalHeader.vue?vue&type=script&lang=js"
export * from "./PortalHeader.vue?vue&type=script&lang=js"
import style0 from "./PortalHeader.vue?vue&type=style&index=0&id=fda07078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda07078",
  null
  
)

export default component.exports